import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import useEarningAndRedemption from "./useEarningAndRedemption";
import SendExcelData from "../../Admin/OrderList/SendExcelData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";

const EarningAndRedemption = () => {
  const {
    date,
    isLoading,
    isFetching,
    showEditModal,
    isExcelLinkSend,
    paginationOptions,
    earningRedemptionList,
    earningRedemptionState,
    handleEarningRedemptionExcelDownload,
    updateEarningRedemptionFields,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    sendExcelData,
    handleSearch,
    modalClose,
    handleSort,
    refetch,
    getRow,
  } = useEarningAndRedemption();

  return (
    <>
      <HeadingGroup title="Earning And Redemption" className={`pro-mb-4`}>
        <div className="col dropdown-filter pro-d-flex">
          <button
            className={`pro-btn pro-btn-outline-primary no-wrap pro-items-center pro-ms-3`}
            type="submit"
            onClick={handleEarningRedemptionExcelDownload}
          >
            <span className="material-symbols-outlined x4">download</span>
            <span>{`Earning And Redemption Data`}</span>
          </button>
        </div>
      </HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={
            earningRedemptionState?.search === "" ? false : true
          }
          handleClear={handleClearClick}
          searchInputProps={{ value: earningRedemptionState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={false}
          dropDownFilter={
            <>
              <div className="col-auto">
                <CustomDateRangePicker
                  defaultDateRange={date}
                  handleDateRangeChange={handleDateRangeChange}
                />
              </div>
            </>
          }
          onDateChange={handleDateChange}
          initialDateRange={date}
        />
        {earningRedemptionList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={earningRedemptionList?.data?.result || []}
            uniqueID={"name"}
            fields={earningRedemptionList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={earningRedemptionState?.clearSelection}
            perpage={earningRedemptionState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {earningRedemptionList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={earningRedemptionState?.currentPage}
            totalPageCount={Math.ceil(
              earningRedemptionList?.data.total_count /
                earningRedemptionState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === earningRedemptionState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={earningRedemptionList?.data?.fields || []}
              moduleId={earningRedemptionList?.data?.module_id}
              updateData={updateEarningRedemptionFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={earningRedemptionState.earningRedemptionExcelSendModal}
          handleClose={handleEarningRedemptionExcelDownload}
          title={`Send Excel Download Link`}
          backdrop="static"
        >
          <div className="pro-m-5">
            <SendExcelData
              isBestSeller
              handleCloseModal={modalClose}
              sendExcelData={sendExcelData}
              isExcelLinkSend={isExcelLinkSend}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default EarningAndRedemption;
